module.exports = __webpack_public_path__ + "img/03.3ec7c26e.png";